// extracted by mini-css-extract-plugin
export default {"tooltip":"W_OO56CAfU_pdp","arrow":"H4JenqKZHQ_pdp","inModal":"cjxCq0i8m3_pdp","disabled":"oVqxlh34Zj_pdp","text":"qmeTzCc2Wg_pdp","wrapper":"o01zOQXbiW_pdp"};